// eslint-disable-next-line @exodus/hydra/definition-satisfies
const removedTokensRedux = {
  id: 'removedTokens.selectors.data',
  factory: () => () => [],
} as const;

export default removedTokensRedux;
